var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzleY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 123,
    viewBox: "0 0 168 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.634 19.4083L151.562 44.7867C151.562 47.3811 149.838 49.9756 146.412 51.9629C142.985 53.9502 138.466 54.9516 133.946 54.9568L134.019 29.5783C138.539 29.5783 143.048 28.5769 146.485 26.5844C149.921 24.5919 151.624 22.0079 151.634 19.4083Z",
    fill: "#EEA009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.493 67.4307L133.42 92.8092C133.42 90.1785 131.681 87.5477 128.213 85.5449C121.272 81.5547 110.067 81.5547 103.172 85.5449C99.7514 87.527 98.033 90.1213 98.0278 92.7209L98.1008 67.3425C98.1008 64.7481 99.8191 62.1537 103.245 60.1663C110.139 56.1762 121.345 56.1762 128.286 60.1663C131.754 62.1692 133.498 64.8 133.493 67.4307Z",
    fill: "#EEA009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.235 48.6887L167.162 74.0672L133.358 93.6393L133.431 68.2609L167.235 48.6887Z",
    fill: "#EEA009"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.406 12.1337C153.342 16.1239 153.379 22.5942 146.485 26.5844C143.048 28.5769 138.539 29.5732 134.019 29.5784L167.235 48.6836L133.446 68.2557C133.863 65.3552 132.139 62.3716 128.286 60.156C121.345 56.1658 110.139 56.1658 103.245 60.156C96.3511 64.1462 96.3875 70.6167 103.328 74.612C107.182 76.8277 112.352 77.8135 117.387 77.5644L83.9531 96.9239L0.119629 48.668L83.4324 0.412109L116.278 19.3097C116.278 16.7153 117.981 14.095 121.418 12.1025C128.239 8.13826 139.471 8.14348 146.406 12.1337Z",
    fill: "#FFC127"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.356 77.5696L117.289 102.948L83.8491 122.313L83.922 96.9342L117.356 77.5696Z",
    fill: "#EEA009"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9219 96.9342L83.849 122.313L0 74.0672L0.0728986 48.6887L83.9219 96.9342Z",
    fill: "#EEA009"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleY);
export default __webpack_public_path__ + "static/media/puzzle-y.923a324379f3390cef3fde0ce8b0888f.svg";
export { ForwardRef as ReactComponent };